export enum SlideTypeEnum {
    MEDIA = "Media",
    QUESTION = "Question",
    TEXT = "Text",
}
